const formsOnPage = document.querySelectorAll('.gform_wrapper')
const urlParams = new URLSearchParams(window.location.search)

if (formsOnPage && urlParams && urlParams.has('utm_campaign')) {

  formsOnPage.forEach((form) => {

    form.querySelectorAll('input[type="hidden"][value="{{utm_campaign}}"]')?.forEach((utmField) => {
      utmField.value = urlParams.get('utm_campaign')
    })

  })

}